import { SPLIT_LOCAL_STORAGE_PREFIX } from "./localStoragePrefix";

export const clearSplitLocalStorageValues = () => {
  Object.keys(localStorage)
    .filter((entryKey) => entryKey.startsWith(`${SPLIT_LOCAL_STORAGE_PREFIX}.`))
    .forEach((entry) => localStorage.removeItem(entry));
};
